// extracted by mini-css-extract-plugin
module.exports = {"bullet":"ob_PaSham","forwardSlash":"ob_rk6hLS","comma":"ob_LUSPWM"};